import { useEffect, useState } from 'react'

import { Button } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import { Delete, Print } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ContentWithOutSubTabs from 'Components/UI/Molecules/ContentWithOutSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { SUCURSAL_ORIGEN } from 'Constants'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import { DataExtra, editFields, ReciboFields } from './Add/Fields'
import AddItem from './Add'

const Recibo = ({
  data,
  onDataChange,
  edit,
  setRender,
  render,
  dataBefore,
  setData,
  closeCancel,
  permissions,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [formEdit, setFormEdit] = useState(data.receiptDetails)
  const [selectedRow, setSelectedRow] = useState(null)
  const createDismissableSnackbar = useCustomSnackbar()

  const origenEncontrado = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.infoMain.origen
  )
  const empresaId = origenEncontrado ? origenEncontrado.id : null
  const [tab, setTab] = useState(0)

  const {
    state: paymentDetail,
    setOpen: setOpenPaymentDetail,
    setClose: setClosePaymentDetail,
  } = SetState()

  const { state: add, setOpen: openAdd, setClose: closeAdd } = SetState()

  const classes = useStyles()

  async function orderInfo(id) {
    await interfaces.salesOrders.infoOneOrders(id).then((res) => {
      setData((prevData) => ({
        ...prevData,
        receipt: res.data.receipt,
        receiptDetails: res.data.receiptDetails,
        infoMain: res.data.infoMain,
      }))
      setFormEdit(res.data.receiptDetails)
    })
  }

  useEffect(() => {
    const id = data.infoMain.id
    orderInfo(id)
    // eslint-disable-next-line
  }, [formEdit.length, data.infoMain.id])

  const createReceipt = async () => {
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesReceipt
      .create(values)
      .then((res) => {
        orderInfo(data.infoMain.id)
        setRender(!render)
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  async function deleteDetail(id) {
    setIsLoading(true)
    const empresa = empresaId
    const recibo = data.receipt.id
    await interfaces.salesReceipt.deleteReceiptItem(id, empresa, recibo).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      deleteItem(id)
    })
    setIsLoading(false)
  }

  async function deleteReceipt() {
    const id = data.receipt.id
    const empresa = empresaId
    setIsLoading(true)
    await interfaces.salesReceipt.deleteReceipt(id, empresa).then((res) => {
      setRender(!render)
      orderInfo(data.infoMain.id)
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
    })
    setIsLoading(false)
  }

  const deleteItem = (id) => {
    let newItem = formEdit.filter((e) => e.id !== id)

    const deletedItem = formEdit.find((e) => e.id === id)
    const deletedImporte = deletedItem ? Number(deletedItem.importe) : 0

    setFormEdit(newItem)
    onDataChange(newItem)
    setData((prevData) => ({
      ...prevData,
      receiptDetails: prevData.receiptDetails.filter((detail) => detail.id !== id),
      receipt: {
        ...prevData.receipt,
        total: Math.trunc(prevData.receipt.total || 0) - Math.trunc(deletedImporte),
        saldoResto: Math.trunc(prevData.receipt.saldoResto || 0) + Math.trunc(deletedImporte),
      },
    }))
  }

  const handleChange = (name, value) => {
    setData({
      ...data,
      receipt: {
        ...data.receipt,
        [name]: value,
      },
    })
  }

  const iconDelete = (id, importe) => (
    <IconButton
      onClick={(event) => {
        event.stopPropagation()
        deleteDetail(id, importe)
      }}
      disabled={data.comprobantes.length > 0 || permissions.allowEditMin ? true : !edit}
      style={{ padding: '0px' }}
    >
      <Delete />
    </IconButton>
  )

  const getMetodoPagoNombre = (id) => {
    const metodo = dataBefore.data.metodosPago.find((metodo) => metodo.id === id)
    return metodo.tipo
  }

  const onClickRow = (index) => {
    if (!edit) return

    const selectedItem = formEdit.find((obj) => obj.id === index.id)

    setSelectedRow(selectedItem)
    setOpenPaymentDetail(true)
  }

  const editItem = async () => {
    if (!selectedRow.importe) {
      createDismissableSnackbar("El campos 'Importe' es obligatorio", {
        variant: 'error',
      })
      return
    }
    setIsLoading(true)
    const values = {
      id: selectedRow.id,
      empresa: empresaId,
      importe: Number(selectedRow.importe.replace(/[^0-9.,]+/g, '')),
      detalle: selectedRow.detalle,
      recibo: data.receipt.id,
      barcode: selectedRow.barcode,
      cupon: selectedRow.cupon,
      lote: selectedRow.lote,
      origen: selectedRow.origen,
      moneda: selectedRow.moneda,
    }

    await interfaces.salesReceipt.editReceiptItem(values).then((res) => {
      const previousRow = formEdit.find((row) => row.id === selectedRow.id)
      const previousImporte = previousRow ? Number(previousRow.importe) : 0
      const importeDifference = values.importe - previousImporte
      const updatedRows = formEdit.map((row) =>
        row.id === selectedRow.id ? { ...row, importe: values.importe } : row
      )
      orderInfo(data.infoMain.id)
      setFormEdit(updatedRows)
      setData((prevData) => ({
        ...prevData,
        receiptDetails: updatedRows,
        receipt: {
          ...prevData.receipt,
          total: Math.trunc(prevData.receipt.total || 0) + Math.trunc(importeDifference),
          saldoResto: Math.trunc(prevData.receipt.saldoResto || 0) - Math.trunc(importeDifference),
        },
      }))
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
    })
    setClosePaymentDetail()
    setIsLoading(false)
    closeCancel()
  }

  const handleChangeItem = (name, value) => {
    setSelectedRow((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  async function print() {
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .printReceipt(values)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Presupuesto impreso con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <div style={{ margin: '2rem' }}>
              <InputsWithoutValidate
                key={data.receipt ? data.receipt.id : 'empty'}
                fields={ReciboFields(data.receipt, handleChange, edit, permissions)}
                spacing={2}
              />
            </div>

            <div
              style={{
                display: 'flex',
                margin: '2rem',
                cursor: edit ? 'pointer' : '',
                overflow: 'scroll',
              }}
            >
              <BasicTable
                col={[
                  { title: 'Medio de pago', style: { width: '80px' } },
                  { title: 'Descripción', style: { width: '100px' } },
                  { title: 'Importe en pesos', style: { width: '80px' } },
                  { title: '', style: { width: '40px' } },
                  { title: '', style: { display: 'none' } },
                ]}
                size="small"
                rows={formEdit?.map((row) => {
                  return {
                    tipo: getMetodoPagoNombre(row.tipo),
                    descripcion: row.descripcion,
                    importe: `$${row.importe}`,
                    action: iconDelete(row.id, row.importe),
                    id: row.id,
                  }
                })}
                onClickRow={permissions.allowEditMin ? () => {} : onClickRow}
              />
              <div>
                <div className={classes.buttons}>
                  <Button
                    onClick={openAdd}
                    disabled={
                      data.comprobantes.length > 0 || permissions.allowEditMin
                        ? true
                        : data.receipt.id
                          ? !edit
                          : true
                    }
                    color="primary"
                    variant="contained"
                    size="large"
                    style={{
                      marginLeft: '1rem',
                      height: '40px',
                    }}
                  >
                    <AddIcon />
                  </Button>

                  <Button
                    onClick={print}
                    disabled={
                      !data.receipt.id ||
                      permissions.allowEditMin ||
                      formEdit.length === 0 ||
                      data.infoMain.estado === 1
                        ? true
                        : !edit
                    }
                    variant="contained"
                    size="large"
                    style={{
                      marginLeft: '1rem',
                      marginRight: '1rem',
                      height: '40px',
                    }}
                  >
                    <Print />
                  </Button>

                  <Button
                    onClick={() => deleteReceipt()}
                    disabled={
                      data.comprobantes.length > 0 || permissions.allowEditMin
                        ? true
                        : data.receipt.id
                          ? !edit
                          : true
                    }
                    variant="contained"
                    size="large"
                    style={{
                      backgroundColor:
                        data.comprobantes.length > 0 || permissions.allowEditMin
                          ? '#e0e0e0'
                          : data.receipt.id
                            ? edit
                              ? '#f44336'
                              : '#e0e0e0'
                            : '#e0e0e0',
                      color:
                        data.comprobantes.length > 0 || permissions.allowEditMin
                          ? '#A9A9A9'
                          : data.receipt.id
                            ? edit
                              ? '#FFF'
                              : '#A9A9A9'
                            : '#A9A9A9',
                      height: '40px',
                      marginRight: '1rem',
                    }}
                  >
                    <Delete />
                  </Button>

                  <CustomButton
                    color="primary"
                    buttonEnd
                    disabled={data.receipt.id ? true : !edit}
                    style={{
                      width: '120px',
                      height: '40px',
                    }}
                    text="Crear recibo"
                    onClick={() => createReceipt()}
                  />
                </div>
                <div style={{ marginTop: '2rem' }}>
                  <InputsWithoutValidate
                    fields={DataExtra(data.receipt, handleChange, edit)}
                    spacing={2}
                    justifyContent="flex-end"
                    key={data.receipt ? data.receipt.id : 'empty'}
                  />
                </div>
              </div>
            </div>
          </>
        )
      default:
        break
    }
  }

  const isSubmitDisabled = selectedRow
    ? selectedRow.tipo === 5
      ? !(
          selectedRow.verificacion &&
          [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(Number(selectedRow.verificacion3))
        )
      : selectedRow.tipo === 1 || selectedRow.tipo === 4
        ? !selectedRow.importe
        : selectedRow.tipo === 2 || selectedRow.tipo === 3
          ? !selectedRow.origen || !selectedRow.importe || !selectedRow.lote || !selectedRow.cupon
          : selectedRow.tipo === 10
            ? !selectedRow.cupon ||
              !selectedRow.importe ||
              !selectedRow.origen ||
              !selectedRow.barcode
            : selectedRow.tipo === 6 || selectedRow.tipo === 7
              ? !selectedRow.importe || !selectedRow.origen || !selectedRow.cupon
              : selectedRow.tipo === 8
                ? !selectedRow.importe || !selectedRow.moneda || !selectedRow.cupon
                : selectedRow.tipo === 51
                  ? !selectedRow.importe || selectedRow.retencion
                  : true
    : true

  return (
    <>
      <ContentWithOutSubTabs value={tab} setValue={setTab} children={renderTabs(tab)} />

      {add.suspense && (
        <AddItem
          data={dataBefore.data}
          open={openAdd}
          handleClose={closeAdd}
          render={render}
          setRender={setRender}
          dataInfo={data}
          setRows={setFormEdit}
          setData={setData}
        />
      )}

      <DialogComponent
        open={paymentDetail.open}
        title="Editar medio de pago"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={
          selectedRow ? (
            <InputsWithoutValidate
              fields={editFields(selectedRow, handleChangeItem, dataBefore.data)}
              spacing={2}
            />
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={isLoading || isSubmitDisabled}
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={editItem}
            onClickCancel={setClosePaymentDetail}
          />
        }
      />
    </>
  )
}

export default Recibo
